export const UPDATE_FIELD_FEEDBACK_FORM = 'UPDATE_FIELD_FEEDBACK_FORM';

export function setFeedBackFormAction(fieldName, value) {
    return {
      type: UPDATE_FIELD_FEEDBACK_FORM,
      fieldName,
      value,
    }
  }